import Vue from 'vue'
import { Component } from 'vue-property-decorator'

import AppDialog from '@/components/AppDialog.vue'
import { AccountAsset } from '@/modules/AccountAsset/interfaces/account-asset'
import { SnackType } from '@/interfaces/snack'
import { showErrors, showNotification } from '@/utils/snack'

import AssetPropertyForm from '@/modules/AccountAsset/components/AssetPropertyForm.vue'
import { deleteAccountAsset } from '@/modules/AccountAsset/gql/account-asset.gql'

@Component({
  components: {
    AppDialog,
    AssetPropertyForm
  }
})
export default class AssetPropertyDialog extends Vue {
  targetAccountAsset: AccountAsset | null = null

  propertyDialog = {
    actionType: 'new',
    show: false,
    title: 'New Asset',
    disable: false
  }

  deletePropertyDialog = {
    show: false,
    title: 'Delete Asset',
    text: ''
  }

  showPropertyEditDialog (e: Event, targetAccountAsset?: AccountAsset) {
    e.preventDefault()
    e.stopPropagation()
    let actionType = 'new'
    let title = 'New Asset'
    if (targetAccountAsset) {
      this.targetAccountAsset = targetAccountAsset
      actionType = 'edit'
      title = 'Edit Asset'
    }
    this.propertyDialog = {
      actionType,
      show: true,
      title,
      disable: false
    }
  }

  hidePropertyEditDialog () {
    this.targetAccountAsset = null
    this.propertyDialog = {
      actionType: 'new',
      show: false,
      title: 'New Property',
      disable: false
    }
  }

  async deleteAccountAsset (e: Event, accountAsset: AccountAsset) {
    e.preventDefault()
    e.stopPropagation()
    this.targetAccountAsset = accountAsset
    this.deletePropertyDialog.show = true
  }

  async deletePropertyPost () {
    if (!this.targetAccountAsset) {
      return
    }
    const { id } = this.targetAccountAsset
    this.deletePropertyDialog.show = false
    try {
      const result = await this.$apollo.mutate({
        mutation: deleteAccountAsset,
        variables: {
          accountAssetId: Number(id)
        }
      })

      const res = result.data.deleteAccountAsset
      if (res) {
        showNotification({
          msg: 'Delete property successfully',
          type: SnackType.Success
        })
        this.targetAccountAsset = null
      }
    } catch (error) {
      showErrors(error.graphQLErrors)
    }
  }
}
